function highlightProduct(activeIndex) {
  document.querySelectorAll(".drawer-product").forEach((product) => {
    product.classList.remove("active-product");
  });

  const activeProduct = document.querySelector(
    `.drawer-product[data-product-index="${activeIndex}"]`
  );

  if (activeProduct) {
    activeProduct.classList.add("active-product");

    setTimeout(() => {
      activeProduct.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }, 100);
  }
}

function toggleDrawer(activeIndex = null) {
  const drawer = document.getElementById("productDrawer");
  const backdrop = document.getElementById("drawer-backdrop");

  drawer.classList.toggle("active");
  backdrop.classList.toggle("active");

  if (activeIndex !== null) {
    highlightProduct(activeIndex);
  }
}

function closeDrawer() {
  const drawer = document.getElementById("productDrawer");
  const backdrop = document.getElementById("drawer-backdrop");

  drawer.classList.remove("active");
  backdrop.classList.remove("active");

  document.querySelectorAll(".drawer-product").forEach((product) => {
    product.classList.remove("active-product");
  });
}

function handleDrawerOutsideClick(event) {
  if (event.target === event.currentTarget) {
    closeDrawer();
  }
}